import { app } from 'cbmms-js/web';

export default function() {
  app.weapp.wx.miniProgram.redirectTo({
    url: app.stringifyLocation({
      pathname: '/pages/own/account/auth-sync',
      searchData: { url: app.getTopPage() },
    }),
  });
}
